const LIKES_KEY = 'authenticulture_likes';

export interface LikeRecord {
  id: string;
  targetId: string;
  targetType: 'video' | 'post' | 'channel_message';
  userId: string;
  createdAt: number;
}

type LikesListener = () => void;
let listeners: LikesListener[] = [];

export function addLikesListener(fn: LikesListener): () => void {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}

function notify() { listeners.forEach(fn => fn()); }

function loadLikes(): LikeRecord[] {
  try { return JSON.parse(localStorage.getItem(LIKES_KEY) ?? '[]'); } catch { return []; }
}

function saveLikes(likes: LikeRecord[]) {
  localStorage.setItem(LIKES_KEY, JSON.stringify(likes));
}

export function saveIncomingLike(like: LikeRecord): void {
  const likes = loadLikes();
  if (likes.find(l => l.id === like.id)) return;
  likes.push(like);
  saveLikes(likes);
  notify();
}

export function getLikeCount(targetId: string): number {
  return loadLikes().filter(l => l.targetId === targetId).length;
}

export function hasLiked(targetId: string, userId: string): boolean {
  return loadLikes().some(l => l.targetId === targetId && l.userId === userId);
}

export function getLikesForTarget(targetId: string): LikeRecord[] {
  return loadLikes().filter(l => l.targetId === targetId);
}

export function getUserLikes(userId: string): LikeRecord[] {
  return loadLikes().filter(l => l.userId === userId);
}
